import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzEaster70 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzEaster70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_EASTER_70: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_EASTER_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_70/pages/subscriptions/SubscriptionEaster70'
      ).then((m) => ({
        default: m.SubscriptionsEaster70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_70/pages/subscriptions/SubscriptionEaster70'
      ),
  },
  [PageId.CHAT_UPSELL_EASTER_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_EASTER_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzEaster70.DOWNLOAD_EASTER_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzEaster70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
